"use client";

import React, { useState, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ArrowRight } from "lucide-react";
export default function ANightInParis() {
  const [offset, setOffset] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!sectionRef.current) return;
    const {
      width,
      height
    } = sectionRef.current.getBoundingClientRect();
    const x = (e.clientX / width - 0.5) * 40;
    const y = (e.clientY / height - 0.5) * 40;
    setOffset({
      x,
      y
    });
  };
  const handleMouseLeave = () => {
    setOffset({
      x: 0,
      y: 0
    });
  };
  return <section data-section-id="9773" id="defining-the-echelon-standard" ref={sectionRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} className="dark bg-background text-foreground relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582385/img/candle_lit_dinner_smoke.png" className="h-full w-full object-cover opacity-60">
          <source src="https://cdn.coverr.co/videos/coverr-smoke-in-the-kitchen-5336/1080p.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-90" />
        {}
        <div className="bg-background/10 absolute inset-0 !bg-[url(https://bursting-mutt.10web.cloud/wp-content/uploads/2026/03/Dark-Modern-Elegant-Singer-New-Song-Youtube-Thumbnail.png)]" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center px-4 text-center">
        {}
        <h1 className="font-serif text-5xl font-light tracking-tight text-primary transition-transform duration-100 ease-out sm:text-7xl md:text-8xl lg:text-[120px] lg:leading-none" style={{
        transform: `translate(${offset.x}px, ${offset.y}px)`,
        textShadow: "0 10px 40px rgba(0,0,0,0.5)"
      }}>
          The Standard of Sophistication
        </h1>

        {}
        <div className="my-10 flex w-full justify-center">
          <Separator className="bg-secondary h-[1px] w-32 shadow-[0_0_10px_var(--color-secondary)] sm:w-48" />
        </div>

        {}
        <div className="transition-transform duration-300 ease-out" style={{
        transform: `translate(${offset.x * 0.5}px, ${offset.y * 0.5}px)`
      }}>
          <Button asChild variant="ghost" size="lg" className="border-secondary/40 text-secondary hover:bg-secondary/10 hover:text-secondary hover:border-secondary border px-8 py-6 text-lg tracking-widest uppercase transition-all duration-300">
            <Link to="/ExperiencePage">
              Explore the Atelier
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}